import React, { Component } from 'react'
import styled from 'styled-components'
import { Icon, DefaultText } from './'
import { FlexWrapper, XLMMText } from './StyledComponents'
import StyledImage from './StyledImage'
const Wrapper = styled.div`
  background-color: #f2ad9f;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  & path {
    stroke: #fff;
  }
  & > div:last-child {
    display: inline-flex;
    height: 20px;
  }
  ${props =>
    props.forWarning &&
    `
    width: 300px !important;
    max-width: 300px !important;
    background: rgb(251, 214, 2);
    padding: 10px 16px !important;
    margin-bottom: 0 !important;
    margin: 30px 10px 0 0px;
    &>div{
      height: auto !important;
      display: flex !important;
    }
  `};
`
class WarningCard extends Component {
  render() {
    const { onClickCard, onClose, text, forWarning, newspaper } = this.props
    return (
      <Wrapper forWarning={forWarning}>
        {forWarning ? (
          <FlexWrapper direction="row" onClick={() => (onClickCard ? onClickCard() : null)}>
            <StyledImage height="70px" src={require('../static/svgs/warning_sign.svg')} />
            <FlexWrapper viewPadding={'0 0 0 16px'}>
              <XLMMText color="#91812b">{newspaper}</XLMMText>
              <DefaultText color="#453a00" fontWeight="600">
                {text}
              </DefaultText>
            </FlexWrapper>
          </FlexWrapper>
        ) : (
          <React.Fragment>
            <div onClick={() => (onClickCard ? onClickCard() : null)}>
              <DefaultText color="#fff">{text}</DefaultText>
            </div>
            <div onClick={() => (onClose ? onClose() : null)}>
              <Icon icon="closeModal" color="#fff" />
            </div>
          </React.Fragment>
        )}
      </Wrapper>
    )
  }
}

export default WarningCard



// WEBPACK FOOTER //
// ./src/components/WarningCard.js